export type LexicalQuickFact = {
  label: string;
  value: string;
  note?: string;
};

type BuildLexicalQuickFactsInput = {
  displayedWord: string;
  dictionaryOnly: boolean;
  baseWord?: string;
  translation?: LexicalQuickFact | null;
};

const ABSENCE_LABELS = new Set([
  "not available",
  "not supplied",
  "no simpler single word substitute",
  "no context safe opposite supplied",
]);

function factKey(value: string) {
  return value
    .toLocaleLowerCase()
    .normalize("NFKC")
    .replace(/[^\p{L}\p{N}]+/gu, " ")
    .trim();
}

export function buildLexicalQuickFacts({
  displayedWord,
  dictionaryOnly,
  baseWord,
  translation,
}: BuildLexicalQuickFactsInput) {
  const facts: LexicalQuickFact[] = [];
  const seen = new Set([factKey(displayedWord)]);

  const add = (
    fact: LexicalQuickFact | null | undefined,
    rejectAbsenceLabel = false,
  ) => {
    if (!fact?.label.trim() || !fact.value.trim()) return;
    const key = factKey(fact.value);
    if (
      !key
      || seen.has(key)
      || (rejectAbsenceLabel && ABSENCE_LABELS.has(key))
    ) {
      return;
    }
    seen.add(key);
    facts.push({ ...fact, value: fact.value.trim() });
  };

  if (dictionaryOnly) {
    add(baseWord ? { label: "Base word", value: baseWord } : null, true);
  } else {
    add(translation);
  }

  return facts;
}
